import PropTypes from 'prop-types';
import React from 'react';
import {
    Container,
    Information,
    Label
} from './styled';

const StatisticsInfo = ({
    info,
    text
}) => (
    <Container>
        <Label> { text } </Label>
        <Information> { info } </Information>
    </Container>
);

StatisticsInfo.propTypes = {
    info: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    text: PropTypes.string
};

export default StatisticsInfo;
